import dayjs from 'dayjs';
import 'dayjs/locale/de';
dayjs.locale('de');
/**
 * Multi-language related operations
 */
type LocaleType = "de" | "en";


export const configureLocale = (name: string) => {
    dayjs.locale(name);
};
 

 